(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luciole-product"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const init=root=>{
  if(!root||root.dataset.ready)return;root.dataset.ready='1';
  const variants=JSON.parse(root.querySelector('[data-variants]').textContent),form=root.querySelector('.lp-form'),id=root.querySelector('[data-variant]'),price=root.querySelector('[data-price]'),compare=root.querySelector('[data-compare]'),stickyPrice=root.querySelector('[data-sticky-price]'),add=root.querySelector('.lp-add'),addText=root.querySelector('[data-add-text]'),main=root.querySelector('.lp-main-image'),currency=root.dataset.currency||'EUR';
  const money=c=>new Intl.NumberFormat(document.documentElement.lang||'fr-FR',{style:'currency',currency}).format(c/100);
  const image=(src,alt)=>{if(!main||!src)return;const change=()=>{main.removeAttribute('srcset');main.removeAttribute('sizes');main.src=src;main.alt=alt||''};document.startViewTransition?document.startViewTransition(change):change()};
  root.querySelectorAll('.lp-thumb').forEach(t=>t.onclick=()=>{root.querySelectorAll('.lp-thumb').forEach(x=>x.classList.remove('is-on'));t.classList.add('is-on');image(t.dataset.src,t.dataset.alt)});
  const colorImage=color=>{const all=[...root.querySelectorAll('.lp-thumb')],target=all.find(t=>(t.dataset.search||'').includes(color.toLowerCase())&&(t.dataset.search||'').includes('halo'))||all.find(t=>(t.dataset.search||'').includes(color.toLowerCase()));if(target)target.click()};
  const update=()=>{const selected=[...root.querySelectorAll('[data-position]')].map(g=>{const c=g.querySelector('input:checked');if(c)g.querySelector('legend span').textContent=c.value;return c?c.value:''}),v=variants.find(x=>x.options.every((o,i)=>o===selected[i]));if(!v)return;id.value=v.id;price.textContent=money(v.price);stickyPrice.textContent=money(v.price);const sale=v.compare_at_price&&v.compare_at_price>v.price;compare.hidden=!sale;compare.textContent=sale?money(v.compare_at_price):'';add.disabled=!v.available;addText.textContent=v.available?root.dataset.add:root.dataset.sold;const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u);if(selected[0])colorImage(selected[0])};
  root.querySelectorAll('[data-position] input').forEach(i=>i.onchange=update);
  const qty=root.querySelector('[name="quantity"]');root.querySelector('[data-minus]').onclick=()=>qty.value=Math.max(1,+qty.value-1);root.querySelector('[data-plus]').onclick=()=>qty.value=Math.max(1,+qty.value+1);
  root.querySelectorAll('[data-scroll]').forEach(b=>b.onclick=()=>root.querySelector('.lp-buy').scrollIntoView({behavior:'smooth',block:'center'}));
  const bar=root.querySelector('[data-sticky]');if(form&&bar&&'IntersectionObserver'in window)new IntersectionObserver(([e])=>bar.classList.toggle('is-on',!e.isIntersecting),{threshold:.15}).observe(form)
 };document.querySelectorAll('.luciole-product').forEach(init);document.addEventListener('shopify:section:load',e=>init(e.target.querySelector('.luciole-product')))
})();

  } catch(e) { console.error(e); }
})();
})();
